<div class="colourpickercontainer">
    <input id="colour" name="colour"
           (ngModelChange)="onChange($event)"
           [(ngModel)]="pickedColour" type="color">
    <input id="colourHex" name="colourHex"
           (ngModelChange)="onChange($event)"
           [(ngModel)]="hexColour" type="text" class="colourHex">
</div>